import React from 'react';
import closeTokens from '@amzn/meridian-tokens/base/icon/close';
import Sheet from '@amzn/meridian/sheet';
import Column from '@amzn/meridian/column';
import Row from '@amzn/meridian/row';
import Button from '@amzn/meridian/button';
import Icon from '@amzn/meridian/icon';
import Heading from '@amzn/meridian/heading';
import Box from '@amzn/meridian/box';
import arrowLeftLargeTokens from '@amzn/meridian-tokens/base/icon/arrow-left-large';
import { useIntl } from 'react-intl';
import SheetContent from './containers/SheetContent';
import useInlineHelp from './hooks/useInlineHelp';
import withIntl from './hoc/withIntl';
import { getpageHistoryStoreValue } from './store/pageHistoryStore';

const SlideOutSheet: React.FC = () => {
  const pageHistory: string[] = getpageHistoryStoreValue();
  const shouldRenderBackButton = pageHistory.length > 0;
  const { pageId, closeInlineHelpSheet, navigateToPrevPage } = useInlineHelp();
  const { formatMessage } = useIntl();
  const open = !!pageId;
  
  if (!pageId) {
    return null;
  }

  return (
    <Sheet type="overlay" side="right" open={open} onClose={closeInlineHelpSheet}>
      <Column spacing="300" width="320px" height="100%" >
        <Row alignmentHorizontal='justify'>
          <Row spacing='none'>
            {shouldRenderBackButton && <Button onClick={navigateToPrevPage} type='icon'>
              <Icon tokens={arrowLeftLargeTokens} />
            </Button>}
            <Heading level={2} >{formatMessage({id:'messages.dev_app.title'})}</Heading>
          </Row>
          <Button onClick={closeInlineHelpSheet} type="icon">
            <Icon tokens={closeTokens} />
          </Button>
        </Row>
        <Box overflowY='scroll'>
          <SheetContent
            pageId={pageId}
          />
        </Box>
      </Column>  
    </Sheet>
  );
};

export default withIntl(SlideOutSheet);
